<template>
  <div
    v-if="!subscriber.isNoAds"
    :key="params"
    class="c-ad-intext-roll"
  ></div>
</template>

<script>
  const FW_SERVER = '//cdn.stickyadstv.com/prime-time/intext-roll.min.js';

  export default {
    name: 'AdIntextRoll',
    props: {
      params: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        subscriber: this.$services.resolve('subscriber'),
      };
    },
    mounted() {
      if (this.subscriber.isNoAds) {
        return;
      }

      const script = document.createElement('script');

      script.type = 'text/javascript';
      script.async = true;
      script.src = `${document.location.protocol}${FW_SERVER}?${this.params}`;

      this.$el.appendChild(script);
    },
  };
</script>
